import store from '@/store'
import axios from 'axios'
export const serializeQuery = (obj: { [x: string]: any }) => {
  let str =
    '?' +
    Object.keys(obj)
      .reduce((a: Array<number | string | boolean>, k) => {
        a.push(k + '=' + encodeURIComponent(obj[k]));
        return a;
      }, [])
      .join('&');
  return str;
};

export const getQueryString = (name: string, url: string) => {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  let r: any = ''
  if (url && url.length > 0) {
    r = url.match(reg)
  } else {
    r = window.location.search.substr(1).match(reg);
  }
  if (r != null) {
      return decodeURIComponent(r[2]);
  };
  return null;
}

export const isMobile = () => {
  // let userAgent = navigator.userAgent;
  // let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  // return Agents.some(i => {
  //   return userAgent.includes(i);
  // });
  // return true
  return /(iPhone|iPad|iPod|iOS|Android|Linux armv8l|Linux armv7l|Linux aarch64)/i.test(navigator.userAgent)
};

export const deviceType = (() => {
  let ua = navigator.userAgent;
  let isWindowsPhone = /(?:Windows Phone)/.test(ua);
  let isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
  let isAndroid = /(?:Android)/.test(ua);
  let isFireFox = /(?:Firefox)/.test(ua);
  let isChrome = /(?:Chrome|CriOS)/.test(ua);
  let isTablet =
    /(?:iPad|PlayBook)/.test(ua) ||
    (isAndroid && !/(?:Mobile)/.test(ua)) ||
    (isFireFox && /(?:Tablet)/.test(ua));
  let isPhone = /(?:iPhone)/.test(ua) && !isTablet;
  let isPc = !isPhone && !isAndroid && !isSymbian;
  return {
    isTablet,
    isPhone,
    isAndroid,
    isPc,
  };
})();

const generBase64Trans = (base64Str: string) => {
  let [base64head, base64Body] = base64Str.split(',');
  let strArr = base64head.match(/:(.*?);/);
  let mime = strArr ? strArr[1] : '';
  let str = atob(base64Body);
  let n = str.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = str.charCodeAt(n);
  }
  return { u8arr, mime };
};

export const base64ToBlob = (base64Str: string) => {
  let { u8arr, mime } = generBase64Trans(base64Str);
  return new Blob([u8arr], { type: mime });
};

export const base64ToFile = (base64Str: string) => {
  let { u8arr, mime } = generBase64Trans(base64Str);
  return new File([u8arr], String(new Date()), { type: mime });
};

export const fileToBase64 = (file: File) => {
  const SIZE = 2 * 1024 * 1024; // limit file size, if larger than Size, compress it
  return new Promise((res, rej) => {
    let reader = new FileReader();
    reader.onload = ev => {
      let base64String = null
      if (ev.target) {
        base64String = ev.target.result
      }
      if (file.size > SIZE) {
        let ratio = Math.ceil((SIZE / file.size) * 10000) / 1e4;
        compressImg(base64String as string, ratio)
          .then(str => {
            res(str);
          })
          .catch(e => {
            console.warn(e);
          });
      } else {
        res(base64String);
      }
    };
    try {
      reader.readAsDataURL(file);
    } catch (e) {
      rej(e);
    }
  });
};

export const compressImg = (file: string, size: number) => {
  let { mime } = generBase64Trans(file);
  return new Promise((res, rej) => {
    let imgObject = new Image();
    let $canvas = document.createElement('canvas');
    imgObject.src = file;
    imgObject.onload = ev => {
      try {
        $canvas.width = imgObject.width;
        $canvas.height = imgObject.height;
        let ctx = $canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(imgObject, 0, 0);
        }
        res($canvas.toDataURL(mime, size));
      } catch (e) {
        rej(e);
      }
    };
    imgObject.onerror = (e: any) => rej(e);
  });
};

// horizen rotate
export const imageDataHorizRevert = (sourceData: ImageData, newData: ImageData) => {
  for (let i = 0, h = sourceData.height; i < h; i++) {
    for (let j = 0, w = sourceData.width; j < w; j++) {
      newData.data[i * w * 4 + j * 4 + 0] = sourceData.data[i * w * 4 + (w - j) * 4 + 0];
      newData.data[i * w * 4 + j * 4 + 1] = sourceData.data[i * w * 4 + (w - j) * 4 + 1];
      newData.data[i * w * 4 + j * 4 + 2] = sourceData.data[i * w * 4 + (w - j) * 4 + 2];
      newData.data[i * w * 4 + j * 4 + 3] = sourceData.data[i * w * 4 + (w - j) * 4 + 3];
    }
  }
  return newData;
};

export const getToken = () => {
  return new Promise((resolve, reject) => {
    axios({
      baseURL: 'https://api.advai.net',
      url: '/openapi/liveness/v1/h5/token',
      method: 'POST',
      headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-ADVAI-KEY': '63761fb9e7d2c123',
      },
      data: {
        returnUrl: 'https://advance.ai',
        tryCount: 5,
      },
    }).then(res => {
      resolve(res.data.data)
    }).catch(e => {
      reject(e)
    })
  })
}

export const sendMessage = <T = Record<string, unknown>>(data: T, child?: Window, origin?: string) => {
  const currentOrigin = origin || '*'
  if (child) {
    child.postMessage(JSON.stringify(data), currentOrigin)
    return
  }
  window.parent.postMessage(JSON.stringify(data), currentOrigin)
}

// 中文字符2个长度，数字、字母和字符占一个长度
export const cutString = (str: string, length: number) => {
  if (length >= str.length) {
    return str;
  }

  let currentLength = 0;
  const isChineseCharReg = /[\u4e00-\u9fa5]/
  for (let i = 0; i < str.length; i++) {
    if (isChineseCharReg.test(str[i])) {
      currentLength += 2;
    } else {
      currentLength += 1;
    }

    if (currentLength > length) {
      return str.substr(0, i);
    } else if (currentLength === length) {
      return str.substr(0, i + 1);
    }
  }
}

export const appSource = () => {
  const u = navigator.userAgent
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  if (isiOS) {
    return 'iOS'
  } else {
    return 'Android'
  }
}
